import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";
import React from "react";

const { Title, Paragraph, Text } = Typography;

const SmsPrivacy = ({ hide, visible }) => {
  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <span className="text-[#000833] text-[15px] mr-[12%] md:mr-[45%]">
            SMS Privacy Policy
          </span>
          <Button
            type="text"
            icon={<CloseOutlined className="text-[20px]" />}
            onClick={hide}
          />
        </div>
      }
      open={visible}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="profile-modal"
      closeIcon={null}
      footer={null}
      bodyStyle={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <Typography>
        <Paragraph>
          <Text strong style={{ color: "#222" }}>
            Effective: July 1, 2025
          </Text>
        </Paragraph>

        <Paragraph style={{ color: "#333" }}>
          This SMS Privacy Policy outlines how AdvantEdge, LLC collects, uses,
          discloses, and manages personal data from individuals who opt into our
          SMS program. We are committed to protecting your privacy and ensuring
          that your personal information is handled in a safe and responsible
          manner.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Information we collect
        </Title>
        <Paragraph style={{ color: "#333" }}>
          When you opt for our SMS program, we may collect the following types
          of personal information:
        </Paragraph>

        <ul style={{ color: "#333" }}>
          <li>
            <span className="font-bold">Contact Information: </span>This
            includes your name, phone number, and any other information you
            provide when you sign up for our SMS services.
          </li>
          <li>
            <span className="font-bold">Usage information:</span> We may collect
            information about how you interact with our SMS messages, such as
            the date and time you receive and read our messages, and your
            responses to our messages.
          </li>
        </ul>

        <Title level={4} style={{ color: "#000833" }}>
          How We Use Your Information
        </Title>
        <Paragraph style={{ color: "#333" }}>
          We use the information we collect for the following purposes:
        </Paragraph>

        <ul style={{ color: "#333" }}>
          <li>
            <span className="font-bold">Communication:</span> To send you SMS
            messages related to our services, promotions, and updates.
          </li>
          <li>
            <span className="font-bold"> Customer Service:</span> To respond to
            your inquiries and provide customer service.
          </li>
          <li>
            <span className="font-bold">Marketing:</span> To send you
            promotional messages and offers that may be of interest to you.
          </li>
          <li>
            <span className="font-bold">Analytics:</span> To analyze the
            effectiveness of our SMS campaigns and improve our services.
          </li>
        </ul>

        <Title level={4} style={{ color: "#000833" }}>
          Sharing Your Information
        </Title>
        <Paragraph style={{ color: "#333" }}>
          We do not sell, trade, or otherwise transfer your personal information
          to outside parties except as described below:
        </Paragraph>

        <ul style={{ color: "#333" }}>
          <li>
            <span className="font-bold">Service Providers:</span> We may share
            your information with third-party service providers who assist us in
            operating our SMS program and conducting our business.
          </li>
          <li>
            <span className="font-bold">Legal Requirements:</span> We may
            disclose your information if required to do so by law or in response
            to a valid request by a law enforcement or government authority.
          </li>
        </ul>

        <Title level={4} style={{ color: "#000833" }}>
          Your Choices
        </Title>
        <Paragraph style={{ color: "#333" }}>
          You have the following choices regarding your personal information:
        </Paragraph>

        <ul style={{ color: "#333" }}>
          <li>
            <span className="font-bold">Opt-Out:</span> You can opt out of
            receiving SMS messages from us at any time by following the
            instructions provided in our messages.
          </li>
          <li>
            <span className="font-bold">Access and Correction:</span> You can
            request access to or collection of your personal information by
            contacting us at the information provided below.
          </li>
        </ul>

        <Title level={4} style={{ color: "#000833" }}>
          Security
        </Title>
        <Paragraph style={{ color: "#333" }}>
          We take reasonable measures to protect your personal information from
          unauthorized access, use, or disclosure. However, no method of
          transmission over the internet or method of electronic storage is 100%
          secure.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Changes to This Policy
        </Title>
        <Paragraph style={{ color: "#333" }}>
          We may update this SMS Privacy Policy from time to time. We will
          notify you of any changes by posting the new policy on our website and
          updating the effective date at the top of this policy.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Contact Us
        </Title>
        <Paragraph style={{ color: "#333" }}>
          If you have any questions or concerns about this SMS Privacy Policy,
          please contact us at:{" "}
          <a href="mailto:support@myrxadvantedge.com">
            support@myrxadvantedge.com
          </a>
        </Paragraph>
      </Typography>
    </Modal>
  );
};

export default SmsPrivacy;
